import { Dpe } from 'types/realEstate.enum';

export const getDpeGrades = (): Dpe[] => Object.values(Dpe).splice(2);
